"use strict";
/*
* Copyright (c) Trainline Limited, 2017. All rights reserved.
* See LICENSE.txt in the project root for license information.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var createSkeletonElement_1 = require("./createSkeletonElement");
var createSkeletonProvider_1 = require("./createSkeletonProvider");
exports.createSkeletonProvider = createSkeletonProvider_1.createSkeletonProvider;
var createSkeletonElement_2 = require("./createSkeletonElement");
exports.createSkeletonElement = createSkeletonElement_2.createSkeletonElement;
exports.default = createSkeletonElement_1.createSkeletonElement;
//# sourceMappingURL=index.js.map